// extracted by mini-css-extract-plugin
export default {"saerchTermPanelContainer":"SearchTermPanel_saerchTermPanelContainer__2PGZG","row":"SearchTermPanel_row__7rDV2"};